import { useCart } from 'context/CartContext';
import { formatUGX } from '../api/getProducts';

export function CartLineItem({ item }) {
  const { updateQty, removeItem } = useCart();

  return (
    <div className="flex gap-4 border-b border-white/10 py-5 last:border-b-0">
      <img src={item.img} alt={item.name} className="h-20 w-20 shrink-0 rounded-xl object-cover" />

      <div className="flex flex-1 flex-col justify-between gap-2">
        <div>
          <div className="text-[0.65rem] font-bold uppercase tracking-wide text-accent">
            {item.cat}
          </div>
          <div className="text-sm font-extrabold leading-snug sm:text-base">{item.name}</div>
        </div>

        <div className="flex flex-wrap items-center justify-between gap-3">
          <div className="flex items-center gap-2 rounded-full border border-white/10 px-1 py-1">
            <StepperButton
              label={`Decrease quantity of ${item.name}`}
              onClick={() => updateQty(item.id, item.qty - 1)}
            >
              −
            </StepperButton>
            <span className="w-6 text-center text-sm font-bold">{item.qty}</span>
            <StepperButton
              label={`Increase quantity of ${item.name}`}
              onClick={() => updateQty(item.id, item.qty + 1)}
            >
              +
            </StepperButton>
          </div>

          <button
            type="button"
            onClick={() => removeItem(item.id)}
            className="text-xs font-bold text-text-dim transition-colors hover:text-[#ff4d4d]"
          >
            Remove
          </button>
        </div>
      </div>

      <div className="shrink-0 text-right">
        <div className="text-sm font-black text-accent">UGX {formatUGX(item.price * item.qty)}</div>
        {item.qty > 1 && (
          <div className="mt-0.5 text-xs text-text-dim">UGX {formatUGX(item.price)} each</div>
        )}
      </div>
    </div>
  );
}

function StepperButton({ children, label, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={label}
      className="flex h-6 w-6 items-center justify-center rounded-full text-sm font-bold text-text-muted transition-colors hover:bg-white/10 hover:text-text"
    >
      {children}
    </button>
  );
}
